__turbopack_context__.v({
  "actions": "MediaField-module__Gyvuja__actions",
  "button": "MediaField-module__Gyvuja__button",
  "error": "MediaField-module__Gyvuja__error",
  "field": "MediaField-module__Gyvuja__field",
  "grid": "MediaField-module__Gyvuja__grid",
  "hint": "MediaField-module__Gyvuja__hint",
  "input": "MediaField-module__Gyvuja__input",
  "library": "MediaField-module__Gyvuja__library",
  "preview": "MediaField-module__Gyvuja__preview",
  "primary": "MediaField-module__Gyvuja__primary",
  "tile": "MediaField-module__Gyvuja__tile",
  "upload": "MediaField-module__Gyvuja__upload",
});
